/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ComparableEngagements } from '../models';
import { GetComparableQuestionsDto } from '../models';
/**
 * ComparableEngagementsApi - axios parameter creator
 * @export
 */
export const ComparableEngagementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete the comparative report associated to the given ComparableEngagements.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        comparableEngagementsControllerDeleteComparativeReport: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling comparableEngagementsControllerDeleteComparativeReport.');
            }
            const localVarPath = `/api/comparable-engagements/{id}/comparative-report/delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find a ComparableEngagements object by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        comparableEngagementsControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling comparableEngagementsControllerFindOne.');
            }
            const localVarPath = `/api/comparable-engagements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate a comparative report for a given ComparableEngagements
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        comparableEngagementsControllerGenerateComparativeReport: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling comparableEngagementsControllerGenerateComparativeReport.');
            }
            const localVarPath = `/api/comparable-engagements/{id}/generate-comparative-report`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all ComparableEngagements including this engagement
         * @param {string} engagementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        comparableEngagementsControllerGetAll: async (engagementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'engagementId' is not null or undefined
            if (engagementId === null || engagementId === undefined) {
                throw new RequiredError('engagementId','Required parameter engagementId was null or undefined when calling comparableEngagementsControllerGetAll.');
            }
            const localVarPath = `/api/comparable-engagements/{engagementId}/get-all`
                .replace(`{${"engagementId"}}`, encodeURIComponent(String(engagementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the ComparableQuestions associated with a ComparableEngagements
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        comparableEngagementsControllerGetComparableQuestions: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling comparableEngagementsControllerGetComparableQuestions.');
            }
            const localVarPath = `/api/comparable-engagements/{id}/comparable-questions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one ComparableEngagements for these 2 engagements
         * @param {string} engagementId 
         * @param {string} comparableEngagementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        comparableEngagementsControllerGetOne: async (engagementId: string, comparableEngagementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'engagementId' is not null or undefined
            if (engagementId === null || engagementId === undefined) {
                throw new RequiredError('engagementId','Required parameter engagementId was null or undefined when calling comparableEngagementsControllerGetOne.');
            }
            // verify required parameter 'comparableEngagementId' is not null or undefined
            if (comparableEngagementId === null || comparableEngagementId === undefined) {
                throw new RequiredError('comparableEngagementId','Required parameter comparableEngagementId was null or undefined when calling comparableEngagementsControllerGetOne.');
            }
            const localVarPath = `/api/comparable-engagements/{engagementId}/get-one/{comparableEngagementId}`
                .replace(`{${"engagementId"}}`, encodeURIComponent(String(engagementId)))
                .replace(`{${"comparableEngagementId"}}`, encodeURIComponent(String(comparableEngagementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run the AI comparisons (generate a global report, list and generate report for comparable questions) for a given ComparableEngagements
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        comparableEngagementsControllerRunAIComparisons: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling comparableEngagementsControllerRunAIComparisons.');
            }
            const localVarPath = `/api/comparable-engagements/{id}/run-comparisons`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComparableEngagementsApi - functional programming interface
 * @export
 */
export const ComparableEngagementsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete the comparative report associated to the given ComparableEngagements.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerDeleteComparativeReport(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ComparableEngagements>>> {
            const localVarAxiosArgs = await ComparableEngagementsApiAxiosParamCreator(configuration).comparableEngagementsControllerDeleteComparativeReport(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find a ComparableEngagements object by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ComparableEngagements>>> {
            const localVarAxiosArgs = await ComparableEngagementsApiAxiosParamCreator(configuration).comparableEngagementsControllerFindOne(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Generate a comparative report for a given ComparableEngagements
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerGenerateComparativeReport(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<string>>> {
            const localVarAxiosArgs = await ComparableEngagementsApiAxiosParamCreator(configuration).comparableEngagementsControllerGenerateComparativeReport(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all ComparableEngagements including this engagement
         * @param {string} engagementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerGetAll(engagementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ComparableEngagements>>>> {
            const localVarAxiosArgs = await ComparableEngagementsApiAxiosParamCreator(configuration).comparableEngagementsControllerGetAll(engagementId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the ComparableQuestions associated with a ComparableEngagements
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerGetComparableQuestions(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<GetComparableQuestionsDto>>>> {
            const localVarAxiosArgs = await ComparableEngagementsApiAxiosParamCreator(configuration).comparableEngagementsControllerGetComparableQuestions(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get one ComparableEngagements for these 2 engagements
         * @param {string} engagementId 
         * @param {string} comparableEngagementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerGetOne(engagementId: string, comparableEngagementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ComparableEngagements>>> {
            const localVarAxiosArgs = await ComparableEngagementsApiAxiosParamCreator(configuration).comparableEngagementsControllerGetOne(engagementId, comparableEngagementId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Run the AI comparisons (generate a global report, list and generate report for comparable questions) for a given ComparableEngagements
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerRunAIComparisons(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ComparableEngagementsApiAxiosParamCreator(configuration).comparableEngagementsControllerRunAIComparisons(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ComparableEngagementsApi - factory interface
 * @export
 */
export const ComparableEngagementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Delete the comparative report associated to the given ComparableEngagements.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerDeleteComparativeReport(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<ComparableEngagements>> {
            return ComparableEngagementsApiFp(configuration).comparableEngagementsControllerDeleteComparativeReport(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find a ComparableEngagements object by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<ComparableEngagements>> {
            return ComparableEngagementsApiFp(configuration).comparableEngagementsControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate a comparative report for a given ComparableEngagements
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerGenerateComparativeReport(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<string>> {
            return ComparableEngagementsApiFp(configuration).comparableEngagementsControllerGenerateComparativeReport(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all ComparableEngagements including this engagement
         * @param {string} engagementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerGetAll(engagementId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ComparableEngagements>>> {
            return ComparableEngagementsApiFp(configuration).comparableEngagementsControllerGetAll(engagementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the ComparableQuestions associated with a ComparableEngagements
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerGetComparableQuestions(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<GetComparableQuestionsDto>>> {
            return ComparableEngagementsApiFp(configuration).comparableEngagementsControllerGetComparableQuestions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one ComparableEngagements for these 2 engagements
         * @param {string} engagementId 
         * @param {string} comparableEngagementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerGetOne(engagementId: string, comparableEngagementId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<ComparableEngagements>> {
            return ComparableEngagementsApiFp(configuration).comparableEngagementsControllerGetOne(engagementId, comparableEngagementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run the AI comparisons (generate a global report, list and generate report for comparable questions) for a given ComparableEngagements
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableEngagementsControllerRunAIComparisons(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ComparableEngagementsApiFp(configuration).comparableEngagementsControllerRunAIComparisons(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComparableEngagementsApi - object-oriented interface
 * @export
 * @class ComparableEngagementsApi
 * @extends {BaseAPI}
 */
export class ComparableEngagementsApi extends BaseAPI {
    /**
     * 
     * @summary Delete the comparative report associated to the given ComparableEngagements.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparableEngagementsApi
     */
    public async comparableEngagementsControllerDeleteComparativeReport(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<ComparableEngagements>> {
        return ComparableEngagementsApiFp(this.configuration).comparableEngagementsControllerDeleteComparativeReport(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Find a ComparableEngagements object by its ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparableEngagementsApi
     */
    public async comparableEngagementsControllerFindOne(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<ComparableEngagements>> {
        return ComparableEngagementsApiFp(this.configuration).comparableEngagementsControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Generate a comparative report for a given ComparableEngagements
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparableEngagementsApi
     */
    public async comparableEngagementsControllerGenerateComparativeReport(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<string>> {
        return ComparableEngagementsApiFp(this.configuration).comparableEngagementsControllerGenerateComparativeReport(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get all ComparableEngagements including this engagement
     * @param {string} engagementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparableEngagementsApi
     */
    public async comparableEngagementsControllerGetAll(engagementId: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ComparableEngagements>>> {
        return ComparableEngagementsApiFp(this.configuration).comparableEngagementsControllerGetAll(engagementId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get the ComparableQuestions associated with a ComparableEngagements
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparableEngagementsApi
     */
    public async comparableEngagementsControllerGetComparableQuestions(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<GetComparableQuestionsDto>>> {
        return ComparableEngagementsApiFp(this.configuration).comparableEngagementsControllerGetComparableQuestions(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get one ComparableEngagements for these 2 engagements
     * @param {string} engagementId 
     * @param {string} comparableEngagementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparableEngagementsApi
     */
    public async comparableEngagementsControllerGetOne(engagementId: string, comparableEngagementId: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<ComparableEngagements>> {
        return ComparableEngagementsApiFp(this.configuration).comparableEngagementsControllerGetOne(engagementId, comparableEngagementId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Run the AI comparisons (generate a global report, list and generate report for comparable questions) for a given ComparableEngagements
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparableEngagementsApi
     */
    public async comparableEngagementsControllerRunAIComparisons(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ComparableEngagementsApiFp(this.configuration).comparableEngagementsControllerRunAIComparisons(id, options).then((request) => request(this.axios, this.basePath));
    }
}
